module.exports = __webpack_public_path__ + "img/triple-dots.9cc915ef.svg";